import styled from "@emotion/styled";
import { Colors } from "@snapchat/snap-design-system";

export const TopLensCardContainer = styled.div`
    cursor: pointer;

    display: flex;
    flex-shrink: 0;
    align-items: flex-end;

    width: 193px;
    height: calc(100% - 98px);

    border-radius: 6px;
`;

export const LensInfo = styled.div`
    position: absolute;

    display: flex;

    width: 193px;
    height: 72px;
    padding: 16px;

    background: linear-gradient(180deg, rgba(0, 0, 0, 0%) 0%, rgba(123, 123, 123, 70%) 100%);
    border-radius: 6px;
`;

export const LensIcon = styled.img`
    cursor: pointer;

    width: 40px;
    height: 40px;

    background: ${Colors.Gray.V50};
    border: 1px solid ${Colors.Black.V100};
    border-radius: 60px;
`;

export const LensName = styled.span`
    width: 110px;

    font-size: 12px;
    font-weight: 500;
    font-style: normal;
    line-height: 16px;
`;

export const LensStat = styled.span`
    font-size: 11px;
    font-weight: normal;
    font-style: normal;
    line-height: 14px;
`;

export const NameAndValue = styled.div`
    display: flex;
    flex-direction: column;
    padding-left: 8px;
    color: white;
`;

export const LensCardVideo = styled.video`
    border-radius: 6px;
`;

export const LensCardImg = styled.img`
    width: 193px;
    min-height: 365px;
    border-radius: 6px;
`;

export const LensCardEmptyPreview = styled.div`
    position: relative;

    width: 100%;
    height: 100%;

    background: #f5f5f5;
    border-radius: 6px;
`;
